<!-- Loading spinner -->
<qai-inner-wrap *ngIf="isLoading" class="loading-container">
  <qai-loading
    [label]="'personalizedPractice.LOADING' | transloco"
    [size]="'medium'"
  ></qai-loading>
</qai-inner-wrap>

<qai-inner-wrap *ngIf="!isLoading && displayPreviousSessions">
  <section class="personalized-practice-previous-sessions">
    <!-- Header section with title and filters -->
    <div class="title">
      <!-- Title with session count -->
      <div class="sub-title column">
        {{ "personalizedPractice.PREVIOUS_SESSIONS" | transloco }}
        <div class="sessions">
          {{ filteredTableRows.length }}
          <span>{{ "personalizedPractice.TOTAL" | transloco }}</span>
        </div>
      </div>

      <!-- Filter controls -->
      <div *ngIf="data.length > 0" class="filters">
        {{ "personalizedPractice.FILTERS" | transloco }}

        <!-- Date filter -->
        <qai-datepicker-material
          [disabled]="false"
          [placeholder]="'personalizedPractice.DATE' | transloco"
          [value]="selectedDate"
          [kind]="'secondary'"
          [shape]="'rectangle'"
          [size]="'medium'"
          [endIcon]="'chevron-down'"
          [weight]="'regular'"
          [showClearButton]="true"
          [locale]="currentLocale"
          (valueChange)="onDateChange($event)"
        ></qai-datepicker-material>

        <!-- Conversation type filter -->
        <qai-floating-select
          class="select-large"
          [placeholder]="'personalizedPractice.CONVERSATION_TYPE' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [showClearButton]="true"
          [options]="conversationTypeOptions"
          [value]="conversationTypeSelectedValue"
          (valueChange)="onConversationTypeChange($event)"
        ></qai-floating-select>

        <!-- Difficulty filter -->
        <qai-floating-select
          [placeholder]="'personalizedPractice.DIFFICULTY' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [showClearButton]="true"
          [options]="difficultyTypeOptions"
          [value]="difficultyTypeSelectedValue"
          (valueChange)="onDifficultyChange($event)"
        ></qai-floating-select>

        <!-- Temperament filter -->
        <qai-floating-select
          [placeholder]="'personalizedPractice.TEMPERAMENT' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [showClearButton]="true"
          [options]="temperamentTypeOptions"
          [value]="temperamentTypeSelectedValue"
          (valueChange)="onTemperamentChange($event)"
        ></qai-floating-select>
      </div>
    </div>

    <!-- Chart visualization of session scores -->
    <app-personalized-practice-chart
      *ngIf="hasFilteredSessions"
      [sessionData]="filteredSessions"
    ></app-personalized-practice-chart>

    <!-- Sessions data table -->
    <qai-table
      [headers]="headers"
      [data]="filteredTableRows"
      [striped]="false"
      [pageSize]="10"
      [currentPage]="1"
      [showPagination]="true"
      [clickableHeader]="true"
      [noDataMessage]="'personalizedPractice.NO_SESSIONS_FOUND' | transloco"
      [previousLabel]="'personalizedPractice.PAGINATION_PREVIOUS' | transloco"
      [nextLabel]="'personalizedPractice.PAGINATION_NEXT' | transloco"
      (cellClick)="onCellViewFeedbackClick($event)"
    ></qai-table>
  </section>
</qai-inner-wrap>
